
import Vue from 'vue'
import { getRegion }  from '@/utils/common'

export default Vue.extend({
  name: 'FinalPriceLabel',
  props: {
    priceTag: {
      type: String,
      default: ''
    }
  },
  computed: {
    regionTaxLabel(): string {
      return getRegion()?.region == 'my' ? 'SST' : 'GST'
    }
  }
})
